










import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import ThumbnailStatus from '@/enums/ThumbnailStatus';

@Component({
	name: 'Thumbnail'
})
export default class Thumbnail extends Vue
{
	private ThumbnailStatus = ThumbnailStatus;

	@Prop()
	private src: string;

	@Prop()
	private alt: string;

	private image: HTMLImageElement;
	private status: number = 0;

	public mounted()
	{
		this.image = new Image();
		this.image.onload = this.onLoad;

		if (this.src)
		{
			this.image.src = this.src;
			this.status = ThumbnailStatus.Loading;
		}
	}

	@Watch('src')
	public onImageSourceChanged()
	{
		this.image.src = this.src;
		this.status = ThumbnailStatus.Loading;
	}

	public onLoad()
	{
		this.status = ThumbnailStatus.Loaded;
	}

	public onLoadError()
	{
		this.status = ThumbnailStatus.Failed;
	}
}
